declare global {
  interface Window {
    gtag_report_conversion?: (url?: string) => boolean;
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * Tracks a custom GA event when available.
 */
const trackEvent = (
  eventName: string,
  params?: Record<string, string | number | boolean>,
): void => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, params ?? {});
  }
};

/**
 * Reports a conversion event to Google Ads.
 * @param url Optional URL to navigate to after conversion is reported.
 */
export const reportConversion = (url?: string): void => {
  if (typeof window !== 'undefined' && window.gtag_report_conversion) {
    window.gtag_report_conversion(url);
  }
};

/**
 * Tracks a successful contact form submission in GA4 and Google Ads conversion.
 */
export const trackContactFormSubmit = (): void => {
  trackEvent('contact_form_submit', { location: 'contact_us_form' });
  reportConversion();
};

/**
 * Tracks WhatsApp CTA click in GA4 and Google Ads conversion.
 */
export const trackWhatsappClick = (): void => {
  trackEvent('whatsapp_click', { location: 'contact_us_page' });
  reportConversion();
};

/**
 * Tracks a help centre article feedback vote. No backend — this is a GA4
 * event only.
 */
export const trackHelpArticleFeedback = (slug: string, helpful: boolean): void => {
  trackEvent('help_article_feedback', { slug, helpful });
};
